import { configureStore, createSelector } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { gqlApi } from 'services/gqlApi';
import { restApi } from 'services/restApi';

import { rtkQueryErrorLogger } from './middlewares/rtkQueryErrorHandler';
import createReducer from './reducer';

const middlewares = [gqlApi.middleware, restApi.middleware, rtkQueryErrorLogger];

export const store = configureStore({
  reducer: createReducer(),
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(middlewares),
  devTools: process.env.NODE_ENV !== 'production',
});

setupListeners(store.dispatch);

export const { dispatch } = store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const createAppSelector = createSelector.withTypes<RootState>();
